import request from './request'

export default (() => ({
  table({ total, page, ...params }) {
    return request.common(
      'get',
      'report/search'
    )({
      total,
      page,
      ...params
    })
  },
  language: {
    filter({ ...params }) {
      return request.common(
        'get',
        'languageMaster'
      )({
        ...params
      })
    },
    search({ type, payloadId, group }) {
      return request.common(
        'get',
        `languageMaster/detail?type=${type}&templateId=${payloadId}&group=${group}`
      )()
    },
    save(data) {
      return request.common('patch', 'languageMaster')(data)
    }
  },
  filters: {
    all() {
      return request.common('get', 'getSearchField')()
    },
    dealerCodes(countryCode) {
      return request.common(
        'get',
        'getSearchField/dealerCodes'
      )({ countryCode })
    },
    branchCodes(dealerCode) {
      return request.common('get', 'getSearchField/branchCodes')({ dealerCode })
    }
  },
  reports: {
    attachment(list) {
      return request.common('get', 'report/resource')({ ids: list })
    },
    csv(data) {
      return request.common(
        'post',
        'report/list'
      )({ params: { ids: data.ids } })
    }
  },
  column: {
    getColumnConfig() {
      return request.common('get', 'columnConfig')()
    },
    updateColumnConfig(data) {
      return request.common('put', 'columnConfig')({ columnConfigs: data })
    }
  },
  transaction: {
    delete(transactions) {
      return request.common(
        'post',
        'transaction/delete'
      )({ transactions: transactions })
    },
    getByIdAndType(data) {
      return request.common(
        'get',
        `evidenceInformation/${data.id}?type=${data.type}`
      )()
    }
  },
  submission: {
    comment: {
      get({ id, part, side }) {
        return request.common(
          'get',
          `submission/technicalDesignComment?submissionId=${id}&part=${part}${
            side ? `&side=${side}` : ''
          }`
        )()
      },
      patch({
        submissionId,
        part,
        side,
        technicalDesignGroup,
        technicalDesignComment
      }) {
        return request.common(
          'patch',
          `submission/technicalDesignComment`
        )(
          side
            ? {
                submissionId,
                part,
                side,
                technicalDesignGroup,
                technicalDesignComment
              }
            : {
                submissionId,
                part,
                technicalDesignGroup,
                technicalDesignComment
              }
        )
      },
      delete(id) {
        return request.common(
          'delete',
          `submission/technicalDesignComment?commentId=${id}`
        )()
      }
    },
    judgement: {
      get({ id, part, side }) {
        return request.common(
          'get',
          `submission/judgementDesign?submissionId=${id}&part=${part}${
            side ? `&side=${side}` : ''
          }`
        )()
      },
      patch({
        submissionId,
        part,
        side,
        judgementDesign,
        qualitySubmission,
        gapUnderstanding,
        wrongLogic,
        others
      }) {
        return request.common(
          'patch',
          'submission/judgementDesign'
        )(
          side
            ? {
                submissionId,
                part,
                side,
                judgementDesign,
                qualitySubmission,
                gapUnderstanding,
                wrongLogic,
                others
              }
            : {
                submissionId,
                part,
                judgementDesign,
                qualitySubmission,
                gapUnderstanding,
                wrongLogic,
                others
              }
        )
      }
    },
    technicalDesignGroup: {
      get() {
        return request.common(
          'get',
          'submission/technicalDesignComment/master'
        )()
      }
    },
    technicalDesignComment: {
      get({ id, part, side }) {
        return request.common(
          'get',
          `submission/technicalDesignComment?submissionId=${id}&part=${part}${
            side ? `&side=${side}` : ''
          }`
        )()
      },
      patch({
        submissionId,
        part,
        type,
        side,
        technicalDesignGroup,
        technicalDesignFeedbackList,
        technicalDesignComment
      }) {
        return request.common(
          'patch',
          `submission/technicalDesignComment`
        )({
          submissionId,
          part,
          type,
          side,
          technicalDesignGroup,
          technicalDesignFeedbackList,
          technicalDesignComment
        })
      }
    },
    technicalDesignFeedback: {
      get() {
        return request.common(
          'get',
          'submission/technicalDesignFeedback/master'
        )()
      }
    }
  },
  photo: {
    get({ diagnosisId, vinNo }) {
      return request.common(
        'get',
        `diagnosis/photo/configuration?diagnosisId=${diagnosisId}&vinNo=${vinNo}`
      )()
    }
  },
  dashboard: {
    import: {
      excel: {
        warranty: {
          post(params) {
            return request.common(
              'post',
              'dashboard/import/excel/warranty'
            )(params)
          }
        }
      },
      latest: {
        get(params) {
          return request.common('get', 'dashboard/import/latest')(params)
        }
      }
    },
    warranty: {
      download: {
        excel: {
          get(params) {
            return request.common(
              'get',
              'dashboard/warranty/download/excel'
            )(params)
          }
        }
      },
      utilizationRatio: {
        get(params) {
          return request.common(
            'get',
            'dashboard/warranty/utilization-ratio'
          )(params)
        },
        downloadExcel: {
          get(params) {
            return request.common(
              'get',
              'dashboard/warranty/utilization-ratio/download-excel'
            )(params)
          }
        }
      },
      utilizationRatioTop10: {
        get(params) {
          return request.common(
            'get',
            'dashboard/warranty/utilization-ratio-dealer-top10'
          )(params)
        }
      },
      accuracyByPart: {
        get(params) {
          return request.common(
            'get',
            'dashboard/warranty/accuracy-by-part'
          )(params)
        }
      },
      benefit: {
        get(params) {
          return request.common('get', 'dashboard/warranty/benefit')(params)
        }
      },
      submissionConcern: {
        get(params) {
          return request.common(
            'get',
            'dashboard/warranty/submission-concern'
          )(params)
        }
      },
      claim: {
        get(params) {
          return request.common('get', 'dashboard/warranty/claim')(params)
        },
        downloadExcel: {
          get(params) {
            return request.common(
              'get',
              'dashboard/warranty/claim/download-excel'
            )(params)
          }
        }
      }
    }
  }
}))()
